import {buryPoint} from '@/Common/plugins/buried-point';

export default {
  openOneHikidModal(where) {
    const op = {
      1: '强制升级',
      2: '建议升级'
    };
    buryPoint.event({
      action: 'OnehikID升级提示-出现升级提示',
      eventCategory: 'OnehikID升级提示',
      eventLabel: op[where]
    });
  },
  clickOnehikdUpgrade(where) {
    const op = {
      1: '强制升级',
      2: '建议升级'
    };
    buryPoint.event({
      action: 'OnehikID升级提示-立即升级',
      eventCategory: 'OnehikID升级提示',
      eventLabel: op[where]
    });
  },
  clickOnehikdLogin(where) {
    const op = {
      1: '强制升级',
      2: '建议升级'
    };
    buryPoint.event({
      action: 'OnehikID升级提示-登录',
      eventCategory: 'OnehikID升级提示',
      eventLabel: op[where]
    });
  },
  onehikidUpgradeResult(where) {
    const op = {
      1: '强制升级',
      2: '建议升级'
    };
    buryPoint.event({
      action: 'OnehikID升级提示-升级成功',
      eventCategory: 'OnehikID升级提示',
      eventLabel: op[where]
    });
  },
  onehikidAccountCantUse() {
    buryPoint.event({
      action: 'OnehikID升级提示-员工账号升级成功无法使用',
      eventCategory: 'OnehikID升级提示'
    });
  }
};